import { ORDER_CANCELLATION as $ST } from 'plugins/tfs/platformConfigs/staticTextMaps/order';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { openImageModal } from 'actions/imageModal';
import PageTitle from 'theme/PageTitle';
import Button from 'theme/Button';
import Icon from 'theme/Icon';
import Image from 'theme/Image';
import CheckBox from 'theme/CheckBox';
import TextBox from 'theme/TextBox';
import ModalSpinner from 'theme/ModalSpinner';
import { useSelector } from 'react-redux';
import { orderStatus, thumbnailImageUrl } from 'theme/utils';
import $S from 'theme/settings';
import { Input } from 'antd';

// pageContainer
import OrderCancelDetail from '_pageContainers/orders/cancellation/orderCancellationDetail';

const OrderCancelDetailGrid = (pageContext) => {
  const orderData = useSelector((state) => state.orderSearch.order);
  const orderDataError = useSelector((state) => state.orderSearch.error);

  const dispatch = useDispatch();

  const {
    props,
    skuFilter,
    refundInvoiceNumber,
    redirect,
    redirectUrl,
    refundedOrderItems,
    isAllChecked,
    order,
    toggleAllCheckbox,
    refundOrderItem,
    refundOrder,
    isCancelOrderButtonVisible,
    cleanStateAndRedirect,
    filterBySku,
    filterByBarcode,
    handleInputChange,
  } = pageContext;

  const renderOrderItems = (orderitemset) => {
    return orderitemset.map((oi, index) => {
      const image =
        oi.product.productimage_set.length &&
        oi.product.productimage_set[0].image;
      return (
        <tr key={index}>
          <td>
            <CheckBox
              icon='check'
              classes='checkbox-table'
              checked={refundedOrderItems[oi.pk] ? true : false}
              disable={
                oi.status === '50' || oi.status === '100' || oi.status === '600'
              }
              onChange={(checked) => refundOrderItem(oi, checked)}
            />
          </td>
          <td>
            <Image
              src={thumbnailImageUrl(image, 90, 90)}
              classes={'product-item__imageWrapper'}
              width={90}
              height={90}
              onClick={() =>
                dispatch(openImageModal(thumbnailImageUrl(image, 600, 600)))
              }
            />
          </td>
          <td>{oi.product.sku}</td>
          <td>{oi.product.attributes.integration_edi}</td>
          <td>{oi.product.name}</td>
          <td>{oi.product.attributes.integration_colorbrand}</td>
          <td>
            {oi.product.attributes.integration_sizeXdescription
              ? oi.product.attributes.integration_sizeXdescription
              : null}
          </td>
          <td>{orderStatus(oi.status)}</td>
        </tr>
      );
    });
  };

  if (Object.keys(orderDataError).length) {
    return (
      <Redirect
        to={{
          pathname: $R.ORDER_CANCELLATION_SEARCH.path,
        }}
      />
    );
  }

  if (!order.pk || redirect) {
    if (redirectUrl) {
      return <Redirect to={redirectUrl} />;
    }
  }

  return Object.keys(orderData).length ? (
    <div
      key={props.location.state ? props.location.state.number : 0}
      className='continer-fluid order-detail'
      style={{ marginTop: '70px' }}
    >
      <div className='col-12'>
        <PageTitle>
          <Button
            classes='pointer float-left'
            onClick={() => cleanStateAndRedirect()}
          >
            {$ST.ORDER_CANCELLATION_ACCEPTANCE}
          </Button>
          <span style={{ fontSize: '16px', margin: '0 5px' }}>
            <Icon icon='oksag' />
          </span>
          {$ST.ORDER_DETAIL}
        </PageTitle>
        <div
          className='row'
          style={{ marginTop: '15px', marginBottom: '15px' }}
        >
          <div className='col-3'>
            <TextBox
              name='skuFilter'
              autocomplete='off'
              onChange={(val) => filterBySku(val)}
              value={skuFilter}
              placeholder={$ST.SEARCH_SKU}
            />
          </div>
          <div className='col-3'>
            <Input
              style={{ height: '53px' }}
              allowClear
              onChange={filterByBarcode}
              placeholder='Please read the barcode to select the product'
            />
          </div>
        </div>
        <h4 className='form-title-hero'>{$ST.PRODUCTS_CAN_BE_CANCEL}</h4>
        <div className='responsive-table'>
          <table className='table'>
            <thead>
              <tr>
                <th>
                  <CheckBox
                    icon='check'
                    classes='checkbox-table'
                    checked={isAllChecked}
                    onChange={(checked) => toggleAllCheckbox(checked)}
                  />
                </th>
                <th />
                <th>{$ST.TABLE.SKU}</th>
                <th>{$ST.TABLE.BARCODE}</th>
                <th>{$ST.TABLE.PRODUCT_NAME}</th>
                <th>{$ST.TABLE.COLOR}</th>
                <th>{$ST.TABLE.SIZE}</th>
                <th>{$ST.TABLE.STATUS}</th>
              </tr>
            </thead>
            <tbody>{renderOrderItems(orderData.orderitem_set)}</tbody>
          </table>
        </div>
        <br />
        <br />
        <div className='order-refund-detail__invoice-number-container'>
          {$S.hasOrderCancelInvoiceNumber && (
            <div className='order-refund-detail__invoice-number-box'>
              <TextBox
                name='refundInvoiceNumber'
                autocomplete='off'
                placeholder={$ST.REFUND_INVOICE_NUMBER}
                value={refundInvoiceNumber}
                onChange={(value) => handleInputChange(value)}
              />
            </div>
          )}
          <Button
            disabled={!isCancelOrderButtonVisible}
            classes='button red pointer float-left'
            onClick={() => refundOrder()}
          >
            {$ST.CANCEL_ORDER}
          </Button>
        </div>
        <br />
        <br />
      </div>
    </div>
  ) : (
    <ModalSpinner />
  );
};

export default OrderCancelDetail(OrderCancelDetailGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/orders/cancellation/orderCancellationDetail/index.js